export default __webpack_public_path__ + "static/media/jaguar.bf1f494d.png";